import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";

import styles from "./AcademicActivites.module.css";

const ConferencePapers = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "conferencePapers",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        title: "",
        conferenceName: "",
        year: "",
        organizer: "",
        indexed: "",
      });
    }
  }, [fields, append]);

  return (
    <div className={styles.borderBox}>
      <div className={styles.heading}>
        <h2>4. Conference Papers / Proceedings</h2>

      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid5} key={item.id}>
          <Input
            label="Title"
            name={`conferencePapers[${idx}].title`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Conference Name"
            name={`conferencePapers[${idx}].conferenceName`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Year"
            name={`conferencePapers[${idx}].year`}
            register={register}
            errors={errors}
            year
            disabled={disabled}
          />
          <Input
            label="Organizer"
            name={`conferencePapers[${idx}].organizer`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Indexed / Not Indexed"
            name={`conferencePapers[${idx}].indexed`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}

      <div className={styles.buttonOuter}>
        <div></div>


        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                title: "",
                conferenceName: "",
                year: "",
                organizer: "",
                indexed: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>
    </div>
  );
};

export default ConferencePapers;
